import React from 'react';
import {connect} from "react-redux";
import {setFacebookAccessToken} from "../../../../../state/actions/authActions";
import {API_ROOT} from "../../../../../baseUrls";
import ImportButton from "./ImportButton";
import {Facebook} from "@mui/icons-material";
import {buildFormData} from "../../../../../state/actions/actionUtils";

function FacebookImport(props) {
  const { mindfile, importSource, facebookAccessToken, setFacebookAccessToken } = props;

  const connectToFacebook = () => {
    let facebookPopup;
    // This function will be called from the facebookPopup window:
    window.facebook_access_token = token => {
      facebookPopup.close();
      setFacebookAccessToken(token);
    };
    facebookPopup = window.open(`${API_ROOT}/mindfiles/${mindfile.id}/facebook/connect`, 'lnFbConnect', 'width=640,height=320');
  }

  return (
    <ImportButton
      importSource={importSource}
      source={"facebook"}
      label={"Facebook"}
      icon={<Facebook />}
      handleConnect={connectToFacebook}
      importFormData={!facebookAccessToken ? null : buildFormData({'facebook_access_token': facebookAccessToken})}
    />
  );
}


const mapStateToProps = state => {
  return {
    mindfile: state.mindfile,
    facebookAccessToken: state.auth.facebook_access_token,
  };
};

const mapDispatchToProps = {
  setFacebookAccessToken
};

export default connect(mapStateToProps, mapDispatchToProps)(FacebookImport);
